import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useParams } from "react-router-dom";
import { addEventTypeAction, updateAdminEventTypeAction, getAdminEventTypeDetailAction } from "../../../store/actions/adminEventType";
import constant from "../../../util/constant";
import eventTypeConstant from "../../../util/eventTypeConstant";
import { CreateEventType } from "../../shared/eventTypes";

const { API_STATUS } = constant;
const { EVENT_TYPE_API_TYPES } = eventTypeConstant;

const AddEditAdminEventType = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { apiType, status, adminEventTypeDetail } = useSelector( state => ( {
    apiType: state.adminEventType.apiType,
    status: state.adminEventType.status,
    adminEventTypeDetail: state.adminEventType.adminEventTypeDetail,
  } ) );
  const { eventTypeId } = useParams();
  const [ isEditEventType, setEditEventTypeStatus ] = useState( false );
  const [ adminEventTypeDetails, setAdminEventTypeDetails ] = useState();

  useEffect( () => {
    if( eventTypeId !== "0" ) {
      setEditEventTypeStatus( true );
      dispatch( getAdminEventTypeDetailAction( eventTypeId ) );
    }
  }, [ eventTypeId ] );

  useEffect( () => {
    if(
      status === API_STATUS.SUCCESS &&
      ( ( apiType === EVENT_TYPE_API_TYPES.ADD_EVENT_TYPE ) ||
        ( apiType === EVENT_TYPE_API_TYPES.UPDATE_ADMIN_EVENT_TYPE ) )
    ) {
      toastr.success( EVENT_TYPE_API_TYPES.ADD_EVENT_TYPE === apiType ? "Event Type added successfully" : "Event Type updated successfully" );
      history.goBack();
    }
    else if( ( status === API_STATUS.SUCCESS ) &&
      ( apiType === EVENT_TYPE_API_TYPES.GET_ADMIN_EVENT_TYPE_DETAIL ) ) {
      setAdminEventTypeDetails( adminEventTypeDetail );
    }
    else if( ( status === API_STATUS.FAILURE ) &&
      ( apiType === EVENT_TYPE_API_TYPES.GET_ADMIN_EVENT_TYPE_DETAIL ) ) {
      history.goBack();
    }
  }, [ apiType, status ] );

  const handleOnSave = ( values ) => {
    const requestObj = {
      // eslint-disable-next-line camelcase
      event_name: values.eventName,
      description: values.description,
      unit: values.units.value,
    };

    if( isEditEventType ) {
      // eslint-disable-next-line camelcase
      requestObj.event_type_id = adminEventTypeDetails.eventTypeId;
      dispatch( updateAdminEventTypeAction( requestObj ) );
    }
    else {
      dispatch( addEventTypeAction( requestObj ) );
    }
  };

  return <CreateEventType isEditEventType={isEditEventType} eventTypeDetail={adminEventTypeDetails} onSave={handleOnSave} />;
};

export default AddEditAdminEventType;
